import React from 'react';
import ChatWindow from '@components/Chat/ChatWindow';
import './App.css';

function App() {
  return (
    <div className="app">
      <ChatWindow isWidget={false} />
    </div>
  );
}

export default App;




